import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Z_INDEX_LAYER } from '@CommonConstants';

const ContextMenu = ({ children, position, style }) => {
  return (
    <Container position={position} style={style}>
      {children}
    </Container>
  );
};

ContextMenu.propTypes = {
  children: PropTypes.node.isRequired,
  position: PropTypes.shape({
    top: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number,
  }),
  style: PropTypes.shape({}),
};

ContextMenu.defaultProps = {
  position: {},
  style: {},
};

const Container = styled.div`
  width: 160px;
  max-height: 200px;
  border-radius: 11px;
  box-shadow: 0px 4px 20px #00000026;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  background-color: ${({ theme }) => theme.colors.ui_1};

  position: absolute;
  ${props => {
    const { position } = props;

    return css`
      top: ${position.top}px;
      bottom: ${position.bottom}px;
      left: ${position.left}px;
      right: ${position.right}px;
    `;
  }}

  z-index: ${Z_INDEX_LAYER.LEVEL_3};
`;

export default ContextMenu;
